import React, { useState } from 'react';
import { Home, LayoutGrid, TicketPercent, User } from 'lucide-react';
import './BottomNav.css';

const BottomNav = ({ activeTab, setActiveTab }) => {

    const navItems = [
        { id: 'Home', icon: Home, label: 'Home' },
        { id: 'Explore', icon: LayoutGrid, label: 'Explore' },
        { id: 'Online', icon: TicketPercent, label: 'Online' }, // Using TicketPercent as placeholder for badge icon
        { id: 'Me', icon: User, label: 'Me' },
    ];

    return (
        <nav className="bottom-nav">
            {navItems.map((item) => {
                const Icon = item.icon;
                const isActive = activeTab === item.id;
                return (
                    <button
                        key={item.id}
                        className={`nav-item ${isActive ? 'active' : ''}`}
                        onClick={() => setActiveTab(item.id)}
                    >
                        <Icon size={24} strokeWidth={isActive ? 2.5 : 2} />
                        <span className="nav-label">{item.label}</span>
                    </button>
                );
            })}
        </nav>
    );
};

export default BottomNav;
